import { postApi } from 'api/fetchApi'

export const restoreDeletedPhotoApi = (photoId: number) =>
  postApi('/photos/undelete', { photoId })
